<template>
  <div v-if="this.language == 'eng'">
    <waterfall :col="col" :data="data">
      <template>
        <div
          class="cell-item wow animate__fadeInDown animate__animated"
          @click="goDetail(item.id)"
          v-for="(item, index) in data"
          :key="index"
        >
          <img
            class="image"
            :src="url + item.picture.fileUrl"
            alt="加载错误"
          />
          <div class="item-body">
            <div class="item-desc">{{ item.englishName }}</div>
            <div class="item-price">￥{{ item.price }}</div>
          </div>
        </div>
      </template>
    </waterfall>
  </div>
  <div v-else-if="this.language == 'en'">
    <waterfall :col="col" :data="data">
      <template>
        <div
          class="cell-item wow animate__fadeInDown animate__animated"
          @click="goDetail(item.id)"
          v-for="(item, index) in data"
          :key="index"
        >
          <img
            class="image"
            :src="url + item.picture.fileUrl"
            alt="ཁུར་སྣོན་ནོར་འཁྲུལ།"
          />
          <div class="item-body">
            <div class="item-desc">{{ item.zangName }}</div>
            <div class="item-price">￥{{ item.price }}</div>
          </div>
        </div>
      </template>
    </waterfall>
  </div>
  <div v-else>
    <waterfall :col="col" :data="data">
      <template>
        <div
          class="cell-item wow animate__fadeInDown animate__animated"
          @click="goDetail(item.id)"
          v-for="(item, index) in data"
          :key="index"
        >
          <img
            class="image"
            :src="url + item.picture.fileUrl"
            alt="加载错误"
          />
          <div class="item-body">
            <div class="item-desc">{{ item.chineseName }}</div>
            <div class="item-price">￥{{ item.price }}</div>
          </div>
        </div>
      </template>
    </waterfall>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      url: process.env.VUE_APP_WEB_URL,
      col: 2,
      language: this.$store.state.language,
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  mounted() {
    new this.$wow.WOW().init();
  },
  created() {},
  methods: {
    goDetail(id) {
      this.$router.push({ path: "/culturalGoodsDetail", query: { id: id } });
    },
  },
};
</script>
<style lang="scss">
@media (max-width: 768px) {
  .vue-waterfall-column {
    .cell-item {
      padding-bottom: .2rem;
      margin: 0 !important;
      box-shadow: none !important;
      .item-body {
        font-size: .3rem!important;
        font-family: "fangzang";
        padding: 10px 0 0 0;
        .item-desc {
          margin-bottom: 12px;
          white-space: normal;
          word-break: break-word;
        }
        .item-price{
          color: #b8945a;
        }
        
      }
    }
  }
}
</style>